export default {
  LAST_UPDATED(state, resp) {
    state.lastUpdatedObjects = resp;
  },
};
